import * as React from 'react';
import type { PiletApi } from '@chess/platform-web';

// The blunders screen: the reader's blunders of the last 30 days, classified.
// One column of sections, bound to this screen's slot: the top bar every
// rail screen shares ("Blunders", no period), then the last 30 days in a tinted
// band labelled "Last 30 days" (`dashboard.band` over `blunders.period`), as on
// the stage screens (2026-10-10). The band's cards and table are plugin
// `shared-mistakes`'s, on `blunders.period`. Its rail
// entry sits in the "mistakes" section with Misses.
const bind = { sections: 'blunders.sections' };

// Phosphor warning (regular): a blunder.
const WARNING = 'M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z';

export function setup(app: PiletApi) {
  app.registerPage('/blunders', () => <app.Extension name="layout" params={{ layout: 'blunders', bind }} />);
  app.registerExtension('rail.entries', () => null, { id: 'blunders', title: 'Blunders', to: '/blunders', icon: WARNING, order: 40, section: 'mistakes' });
  // The top bar: "Blunders" and Sync; the band below names the period.
  app.registerExtension('blunders.sections', () => <app.Extension name="shared.dashboardHeader" params={{ screen: 'Blunders', period: null }} />, { order: 1 });
  // The band: `shared-mistakes`'s section (cards, then the table) on `blunders.period`.
  app.registerExtension('blunders.sections', () => <app.Extension name="dashboard.band" params={{ slot: 'blunders.period' }} />, { order: 2 });
}
